import { BenefitAllocation } from "@/types/benefit-allocation/benefit-allocation";
import { StyledCard } from "./style-components";
import { useState, useEffect, useRef, useCallback } from "react";
import CircularProgress from "@/components/circular-progress/circular-progress";
import { CopyOutlined } from "@ant-design/icons";
import { Typography } from "antd";

interface CodeBenefitProps {
  benefit?: BenefitAllocation;
  updateInterval?: number;
}

const CodeBenefit: React.FC<CodeBenefitProps> = ({ updateInterval = 60 }) => {
  const generateRandomCode = () => Math.floor(100000 + Math.random() * 900000);
  const [remainingTime, setRemainingTime] = useState<number>(updateInterval);
  const [code, setCode] = useState<number>(generateRandomCode);
  const intervalCountDown = useRef<NodeJS.Timeout | null>(null);
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const handleCopyCode = () => {
    navigator.clipboard.writeText(code.toString());
    setIsCopied(true);
  }

  const handleIntervalCountDown = useCallback(async () => {
    if (intervalCountDown.current) {
      clearInterval(intervalCountDown.current);
    }

    setRemainingTime(updateInterval);

    intervalCountDown.current = setInterval(async () => {
      setRemainingTime((prev) => {
        if (prev === 1) {
                  setCode(generateRandomCode());
          return updateInterval;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (intervalCountDown.current) {
        clearInterval(intervalCountDown.current);
      }
    };
  }, [updateInterval]);

  useEffect(() => {
    handleIntervalCountDown();
  }, [handleIntervalCountDown]);

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 1500);
    }
  }, [isCopied]);

  return (
    <>
      <Typography.Text style={{ width: '100%', minHeight: '25px', textAlign: 'center' }}>{isCopied && 'Código copiado'}</Typography.Text>
      <StyledCard>{code} <CopyOutlined onClick={handleCopyCode} /></StyledCard>
      <CircularProgress periodicIntervalInSeconds={updateInterval} remainingTime={remainingTime} />
    </>
  );
};

export default CodeBenefit;
